import React from 'react';
import 'components/ui/header.scss';
import Breadcrumb from './breadcrumb';
import classNames from 'classnames';

export default function Header({ children, crumbs, className, column, actions, noPadding, noBorder }) {
  return (
    <div className={classNames('header-tab', noPadding ? 'px-0' : 'p-10', noBorder ? 'no-border' : '', className)}>
      {column ? (
        <div className="column">
          {(crumbs || actions) && (
            <div className="with-actions">
              {crumbs && <Breadcrumb crumbs={crumbs} />}
              {actions && <div className="d-flex gap-2">{actions}</div>}
            </div>
          )}
          {children}
        </div>
      ) : (
        <>
          {crumbs && <Breadcrumb crumbs={crumbs} />}
          {actions ? <div className="d-flex gap-2">{actions}</div> : children}
        </>
      )}
    </div>
  );
}
